import api from './api';

export const getOrderDatesForInvoice = (storeId) =>
  api.get('/invoices/order-dates', { params: { storeId } }).then(r => r.data);

export const getOrdersByDateForInvoice = (storeId, date) =>
  api.get('/invoices/orders-by-date', { params: { storeId, date } }).then(r => r.data);

export const getOrdersForInvoice = (storeId) =>
  api.get('/invoices/orders', { params: { storeId } }).then(r => r.data);

export const getInvoiceByOrder = (orderId, storeId) =>
  api.get('/invoices/by-order', { params: { orderId, storeId } }).then(r => r.data);

// ← busca por invoiceId directamente (no-order invoices)
export const getInvoiceById = (invoiceId, storeId) =>
  api.get('/invoices/by-order', { params: { invoiceId, storeId } }).then(r => r.data);

export const saveInvoice = (payload) =>
  api.post('/invoices/save', payload).then(r => r.data);

export const getAllInvoices = (storeId) =>
  api.get('/invoices', { params: { storeId } }).then(r => r.data);

export const getProductsForStore = (storeId) =>
  api.get('/invoices/products', { params: { storeId } }).then(r => r.data);

export const getVendorsForStore = (storeId) =>
  api.get('/invoices/vendors', { params: { storeId } }).then(r => r.data);

export const deleteInvoice = (invoiceId, storeId) =>
  api.delete('/invoices/delete', { data: { invoiceId, storeId } }).then(r => r.data);

// ── Fotos de recibo (ahora soporta varias en una sola llamada) ──
// `files` puede ser un FileList (de <input multiple>) o un array de File.
export const uploadReceiptImages = (files, invoiceId, orderId, storeId) => {
  const formData = new FormData();
  Array.from(files).forEach(file => formData.append('receipts', file));
  formData.append('orderId', orderId || '');
  formData.append('storeId', storeId);
  if (invoiceId) formData.append('invoiceId', invoiceId);

  return api.post('/invoices/upload-receipt', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};

// Quita una foto puntual de un invoice ya guardado en BD.
export const removeReceiptImage = (invoiceId, publicId, storeId) =>
  api.post('/invoices/remove-receipt', { invoiceId, publicId, storeId }).then(r => r.data);